import React from "react";
import {
  CountBarContainer,
  BarBox,
  FilledBox,
  EmptyBox,
  TextContainer,
} from "./styles";

function CountBar({ data }) {
  let { normalizedValue, value } = data;
  return (
    <CountBarContainer>
      <BarBox>
        <FilledBox width={normalizedValue * 100}>
          {normalizedValue >= 0.3 && <TextContainer>{value}</TextContainer>}
        </FilledBox>
        <EmptyBox width={(1 - normalizedValue) * 100}>
          {normalizedValue < 0.3 && <TextContainer>{value}</TextContainer>}
        </EmptyBox>
      </BarBox>
    </CountBarContainer>
  );
}
export default CountBar;
